import keys from 'lodash/keys';
import includes from 'lodash/includes';

import PageHistoryTracker from 'zoomforth_zfutils/page_history_tracker.js';

let pageHistoryTrackerSingleton;
let pageHistoryTrackerPageInstances = {};

const init =  function(pageDataOrId) {
  if (!pageDataOrId) {
    throw new Error('`init` of `pageHistoryTracker` singleton must include a page object or page id');
  }
  pageHistoryTrackerSingleton = new PageHistoryTracker(pageDataOrId);
};

const get = function() {
  if (!pageHistoryTrackerSingleton) {
    throw new Error('You must call `init` on `pageHistoryTracker` appglobal before calling `get`');
  }
  return pageHistoryTrackerSingleton;
};

const getForPage = function(pageId) {
  if (!pageId) {
    throw new Error('`getForPage` of `pageHistoryTracker` singleton must include a page id');
  }

  // attempt to access a cached tracker
  if (!includes(keys(pageHistoryTrackerPageInstances), pageId)) {
    pageHistoryTrackerPageInstances[pageId] = new PageHistoryTracker(pageId);
  }

  return pageHistoryTrackerPageInstances[pageId];
}

export { init, get, getForPage };

export default { init, get, getForPage };
